/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProFormaFundOwnershipModel } from './ProFormaFundOwnershipModel';
import type { ProFormaSecurityModel } from './ProFormaSecurityModel';
export type ProFormaCapTableModel = {
  id: number;
  name: string;
  company_measurement_date?: number | null;
  shares_outstanding?: string | null;
  shares_diluted?: string | null;
  current_own_percent?: string | null;
  diluted_own_percent?: string | null;
  initial_liquidation_preference?: string | null;
  is_primary?: boolean;
  securities: Array<ProFormaSecurityModel>;
  fund_ownership: ProFormaFundOwnershipModel;
  waterfall_breakpoints?: any;
  use_custom_breakpoints?: boolean;
  custom_breakpoints?: any;
  has_liquidation_preference_ledger?: boolean;
  has_dividend_rate_ledger?: boolean;
  access_level?: ProFormaCapTableModel.access_level;
};
export namespace ProFormaCapTableModel {
  export enum access_level {
    COLLABORATIVE = 'collaborative',
    RESTRICTED = 'restricted',
    PRIVATE = 'private',
  }
}

